import "../css/verifytable.css";
import Table from "@mui/material/Table";
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Button, Spinner, Modal, Dropdown } from "react-bootstrap"

//firebase
import { useState, useEffect } from "react";
import { db } from "../firestore-db";
import { storage } from "../firebase";
import "firebase/compat/storage";
import { getStorage, ref, getDownloadURL, listAll } from 'firebase/storage';
import 'firebase/compat/firestore';
import {
    query,
    collection,
    getDocs,
    updateDoc,
    deleteDoc,
    doc,
    orderBy,
    where,
    startAt,
    endAt
} from "firebase/firestore";

import * as MdIcons from "react-icons/md";
import * as VsIcons from "react-icons/vsc";
import * as GoIcons from "react-icons/go";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.common.white,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const List = () => {

    const [loading, setLoading] = useState(false)
    const [loadingModal, setLoadingModal] = useState(false);

    const [diplomaUrl, setDipUrl] = useState("");
    const [frontIdUrl, setFrontUrl] = useState("");
    const [backIdUrl, setBackUrl] = useState("");
    const [selfieUrl, setSelfieUrl] = useState("");

    const [selUserDoc, setSelUserDoc] = useState([]);
    const [selUserTypeDoc, setSelUserTypeDoc] = useState([]);
    const [showUser, setShowUser] = useState(false);
    const [showUserType, setShowUserType] = useState("");
    const [showReq, setShowReq] = useState(false);

    const [search, setSearch] = useState("");
    const [fields, setField] = useState("");
    const [verifyReqs, setVerifyReqs] = useState([]);

    const getRequest = async () => {
        setLoading(true);

        if (fields === null) {
            var orderField = "fName";
        }
        else if (fields == "-- Select Filter --") {
            var orderField = "fName";
        }
        else if (fields == "Name") {
            var orderField = "fName";
        }
        else if (fields == "Email") {
            var orderField = "email";
        }
        else if (fields == "Phone Number") {
            var orderField = "phoneNum";
        }
        else if (fields == "User Type") {
            var orderField = "userType";
        }
        else if (fields == "Status") {
            var orderField = "userVerification";
        }

        if (search.length === 0)
            var reqsCollectionRef = query(collection(db, "users"), orderBy("fName"));
        else if (search.length > 1)
            // panget kabonding ni firebase sa query
            var reqsCollectionRef = query(collection(db, "users"), orderBy(orderField), startAt(search), endAt(search + '~'));

        const vrfydata = await getDocs(reqsCollectionRef);
        setVerifyReqs(vrfydata.docs.map((doc) => ({ ...doc.data(), id: doc.id })));

        setTimeout(() => {
            setLoading(false)
        }, 1100);
    };

    const handleCloseUser = () => {
        setShowUser(false)
    };

    const handleShowUser = async (userid, usertypes) => {
        setShowUser(true);
        setLoadingModal(true);

        const getUserRef = db.collection("users");
        const getReqRef = db.collection("verificationRequest");
        setShowUserType(usertypes);

        getReqRef.where("userID", "==", userid)
            .get()
            .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    setSelUserDoc(querySnapshot.docs.map((doc) => doc.data()));

                    getUserRef.where("userID", "==", userid).get()
                    .then((querySnapshot) => {
                        querySnapshot.forEach((doc) => {
                            setSelUserTypeDoc(querySnapshot.docs.map((doc) => doc.data()));
                        });
                    })
                    .catch((error) => {
                        console.log("Error getting UserType documents: ", error);
                    });

                });
            })
            .catch((error) => {
                console.log("Error getting User documents: ", error);
            });

        setTimeout(() => {
            setLoadingModal(false)
        }, 1100);
    };

    const handleCloseReq = () => {
        setShowReq(false)
    };

    const handleShowReq = async (userid, usertypes) => {
        setShowReq(true);
        setLoadingModal(true);

        const diplomaRef = ref(storage, "userids_" + userid + "/userdiploma_" + userid + ".pdf");
        const frontIdRef = ref(storage, "userids_" + userid + "/userid_front_" + userid + ".jpg");
        const backIdRef = ref(storage, "userids_" + userid + "/userid_back_" + userid + ".jpg");
        const selfieRef = ref(storage, "userids_" + userid + "/userselfie_" + userid + ".jpg");

        if (usertypes == "Tutor") {

            getDownloadURL(frontIdRef)
                .then((img1) => {
                    // Inserting url into an object
                    console.log(img1);
                    setFrontUrl(img1);
                })
                .catch((error) => {
                    const noProfileRef = ref(storage, "/no_profile_pic.png");
                    console.log(error)
                    console.log(error.code)
                    getDownloadURL(noProfileRef).then((noImg) => {
                        // Inserting no profile url into an object
                        setFrontUrl(noImg);
                    })

                });

            getDownloadURL(diplomaRef)
                .then((dip) => {
                    // Inserting url into an object
                    console.log(dip);
                    setDipUrl(dip);
                })
                .catch((error) => {
                    const noProfileRef = ref(storage, "/no_profile_pic.png");
                    console.log(error)
                    console.log(error.code)
                    getDownloadURL(noProfileRef).then((noImg) => {
                        // Inserting no profile url into an object
                        setFrontUrl(noImg);
                    })

                });

            getDownloadURL(backIdRef)
                .then((img2) => {
                    // Inserting url into an object
                    console.log(img2);
                    setBackUrl(img2);
                })
                .catch((error) => {
                    const noProfileRef = ref(storage, "/no_profile_pic.png");
                    console.log(error)
                    console.log(error.code)
                    getDownloadURL(noProfileRef).then((noImg) => {
                        // Inserting no profile url into an object
                        setBackUrl(noImg);
                    })

                });

            getDownloadURL(selfieRef)
                .then((img3) => {
                    // Inserting url into an object
                    console.log(img3);
                    setSelfieUrl(img3);
                })
                .catch((error) => {
                    const noProfileRef = ref(storage, "/no_profile_pic.png");
                    console.log(error)
                    console.log(error.code)
                    getDownloadURL(noProfileRef).then((noImg) => {
                        // Inserting no profile url into an object
                        setSelfieUrl(noImg);
                    })

                });

        } else if (usertypes == "Tutee") {

            getDownloadURL(frontIdRef)
                .then((img1) => {
                    // Inserting url into an object
                    console.log(img1);
                    setFrontUrl(img1);
                })
                .catch((error) => {
                    const noProfileRef = ref(storage, "/no_profile_pic.png");
                    console.log(error)
                    console.log(error.code)
                    getDownloadURL(noProfileRef).then((noImg) => {
                        // Inserting no profile url into an object
                        setFrontUrl(noImg);
                    })

                });

        }

        setTimeout(() => {
            setLoadingModal(false)
        }, 1100);
    };

    const handleOpenNewTab = (newTabUrl) => {
        window.open(newTabUrl);
    }

    const handleVerify = async (id, usertypes) => {
        setShowUser(false);
        getRequest();

        console.log(id);
        const userDoc = doc(db, "users", id);
        const newFields = { userVerification: "true" };
        await updateDoc(userDoc, newFields);

        setTimeout(() => {
            handleShowUser(id, usertypes);
        }, 1100);

    };

    const handleUnverify = async (id, usertypes) => {
        setShowUser(false);
        getRequest();

        console.log(id);
        const userDoc = doc(db, "users", id);
        const newFields = { userVerification: "false" };
        await updateDoc(userDoc, newFields);

        setTimeout(() => {
            handleShowUser(id, usertypes);
        }, 1100);
    };

    const deleteUser = async (userid) => {
        const userDoc = doc(db, "verificationRequest", userid);
        console.log(userDoc);
        await deleteDoc(userDoc);
        getRequest();
    };

    // get verificationRequest data
    useEffect(() => {
        getRequest();
    }, [search]);

    return (
        <>

            <div className="ver-header">
                <div className="ver-listTitle">
                    <h4> User Verification </h4>
                </div>

                <div className="ver-drp-search" >
                    <select className="drp-dwn" value={fields} onChange={(e) => setField(e.target.value)}>
                        <option >-- Select Filter --</option>
                        <option >Name</option>
                        <option >Email</option>
                        <option >Phone Number</option>
                        <option >User Type</option>
                        <option >Status</option>
                    </select>
                </div>

                <div className="ver-search">
                    <input
                        className="ver-search-item"
                        placeholder="Search..."
                        onChange={(e) => setSearch(e.target.value.toString())}
                    />
                </div>
            </div>

            <TableContainer component={Paper} className="verify-table">

                {
                    loading ?

                        <div className="loader">
                            <Spinner animation="grow" variant="primary" />
                        </div>

                        :

                        <Table stickyHeader sx={{ minWidth: 650 }} aria-label="sticky table">
                            <TableHead className="tableHeader">
                                <StyledTableRow>
                                    <StyledTableCell className="tableCell">Name</StyledTableCell>
                                    <StyledTableCell className="tableCell">Email</StyledTableCell>
                                    <StyledTableCell className="tableCell">Phone Number</StyledTableCell>
                                    <StyledTableCell className="tableCell">User Type</StyledTableCell>
                                    <StyledTableCell className="tableCell">Status</StyledTableCell>
                                    <StyledTableCell className="tableCell"> </StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>

                                {verifyReqs.map((req) => (
                                    <StyledTableRow hover key={req.userID}>

                                        <TableCell className="tableCell">
                                            {/* <img src={row.img} alt="" className="image" /> */}
                                            <div className="cellWrapper">{req.fName} {req.lName} </div>
                                        </TableCell>
                                        <TableCell className="tableCell"> {req.email} </TableCell>

                                        <TableCell className="tableCell">{req.phoneNum}</TableCell>
                                        <TableCell className="tableCell">{req.userType}</TableCell>
                                        <TableCell className="tableCell">
                                            <span className={`user-vertb-${req.userVerification}`}></span>
                                        </TableCell>

                                        <TableCell className="tableCell">
                                            <div className="actions-btn">
                                                <Button variant="primary" size="sm" onClick={() => { handleShowUser(req.userID,req.userType) }} > <MdIcons.MdOutlineInfo /> Details </Button>

                                                <Button variant="danger" size="sm" onClick={() => { deleteUser(req.userID) }} > <MdIcons.MdOutlineDelete /> Delete </Button>
                                            </div>
                                        </TableCell>

                                    </StyledTableRow>
                                ))}

                            </TableBody>
                        </Table>

                }

            </TableContainer>

            <>
                {/* user details modal */}
                <Modal
                    show={showUser}
                    onHide={handleCloseUser}
                    backdrop="static"
                    keyboard={false}
                >
                    {
                        loadingModal ?

                            <div className="loader">
                                <Spinner animation="grow" variant="primary" />
                            </div>

                            :

                            <>
                                <Modal.Header closeButton>
                                    {/* reqsData */}
                                    {selUserDoc.map((selusers) => (
                                        <Modal.Title> <h3 style={{ paddingTop: '20px' }} > {selusers.fName} {selusers.lName} </h3> </Modal.Title>
                                    ))
                                    }
                                </Modal.Header>

                                <Modal.Body>
                                    {selUserDoc.map((selusers) => (

                                        <>
                                            <p> <strong> ID Type: </strong> {selusers.idType} </p>
                                            <p> <strong> ID Number: </strong> {selusers.idNumber} </p>
                                            <p> <strong> First Name: </strong> {selusers.fName}  </p>
                                            <p> <strong> Middle Name: </strong> {selusers.mName}  </p>
                                            <p> <strong> Last Name: </strong> {selusers.lName} </p>
                                            <p> <strong> Nationality: </strong> {selusers.userNationality} </p>

                                            <p className={`vertb-${showUserType}`}> <strong> Degree: </strong> {selusers.userGradCourse} </p>
                                            <p className={`vertb-${showUserType}`}> <strong> University: </strong> {selusers.userGradSchool}  </p>
                                            <p className={`vertb-${showUserType}`}> <strong> School Year: </strong> {selusers.userGradSchoolYear} </p>
                                        </>

                                    ))}
                                </Modal.Body>

                                <Modal.Footer>
                                    {selUserTypeDoc.map((selusertype) => (
                                        <>
                                            <Button variant="primary" size="sm" onClick={() => { handleShowReq(selusertype.userID, selusertype.userType) }} > <VsIcons.VscFileSubmodule /> Requirements </Button>
                                            <Button variant="success" size="sm" onClick={() => { handleVerify(selusertype.userID, selusertype.userType) }} >Verify User</Button>
                                            <Button variant="danger" size="sm" onClick={() => { handleUnverify(selusertype.userID, selusertype.userType) }}>Unverify User</Button>
                                        </>
                                    ))}
                                </Modal.Footer>
                            </>

                    }
                </Modal>
            </>

            <>
                {/* requiments modal */}
                <Modal
                    size="lg"
                    show={showReq}
                    onHide={handleCloseReq}
                    backdrop="static"
                    keyboard={false}
                >
                    {
                        loadingModal ?

                            <div className="loader">
                                <Spinner animation="grow" variant="primary" />
                            </div>

                            :

                            <>
                                <Modal.Header closeButton>
                                    {/* reqsData */}
                                    <Modal.Title>
                                        <h3 style={{ paddingTop: '20px' }} > Submitted Requirements </h3>
                                    </Modal.Title>
                                </Modal.Header>

                                <Modal.Body>

                                    <p> <strong> Front ID ~ </strong> </p>
                                    <div className="req-container">
                                        <img src={frontIdUrl} alt="profile" className="reqs" />
                                    </div>

                                    {selUserTypeDoc.map((selusertype) => (
                                        <>
                                            <div className={`vertb-${selusertype.userType}`}>

                                                <hr />

                                                <p> <strong> Selfie Picture ~ </strong> </p>
                                                <div className="req-container">
                                                    <img src={selfieUrl} alt="profile" className="reqs" />
                                                </div>

                                            </div>
                                        </>
                                    ))}

                                </Modal.Body>

                                <Modal.Footer>
                                    {selUserTypeDoc.map((selusertype) => (
                                        <div className={`vertb-${selusertype.userType}`}>
                                            <Button onClick={() => { handleOpenNewTab(diplomaUrl) }} variant="primary" className="openDplm"> View Submitted <strong> Diploma </strong> </Button>
                                        </div>
                                    ))}

                                </Modal.Footer>
                            </>

                    }
                </Modal>
            </>

        </>
    );
};

export default List;